export interface Testimonial {
  name: string;
  title: string;
  company: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: "张明远",
    title: "市场总监",
    company: "花颜美妆集团",
    content: "与蜜桃传媒合作一年来，我们的品牌在社交媒体的声量提升了3倍。他们的团队不仅专业高效，更懂得如何用内容打动消费者。特别是在小红书种草营销方面的表现超出预期。",
    rating: 5
  },
  {
    name: "李思琪",
    title: "品牌创始人",
    company: "轻食主义餐饮",
    content: "作为新锐品牌，我们需要快速建立市场认知。蜜桃传媒帮我们策划的短视频营销方案，让品牌在三个月内获得了百万级的曝光，门店客流增长了40%，效果远超预期。",
    rating: 5
  },
  {
    name: "王子豪",
    title: "电商运营总监",
    company: "极客数码科技",
    content: "蜜桃传媒的创意团队非常有想法，他们为我们的新品发布会制作的宣传视频创意十足，在全网传播效果非常好，B站单条视频播放量突破200万。",
    rating: 5
  },
  {
    name: "陈雅文",
    title: "品牌传播经理",
    company: "悦活生活方式品牌",
    content: "专业、靠谱、有创意——这是我对蜜桃传媒最直接的评价。从策略到执行，每个环节都能感受到团队的专业度和用心。他们不只是服务商，更像是我们品牌的合作伙伴。",
    rating: 5
  },
  {
    name: "刘建国",
    title: "CEO",
    company: "星途文旅集团",
    content: "文旅行业的内容营销有其特殊性，蜜桃传媒团队快速理解了我们行业的需求，为我们的多个项目定制了差异化的传播方案，内容质量和服务态度都让我们很满意。",
    rating: 5
  },
  {
    name: "赵雪莹",
    title: "新媒体负责人",
    company: "天然派护肤品牌",
    content: "合作半年，我们的抖音账号粉丝从2万增长到30万+。蜜桃传媒的运营团队对平台算法的理解非常深入，总能抓住最新的流量机会。强烈推荐给想做新媒体运营的品牌。",
    rating: 5
  }
];